export default __webpack_public_path__ + "static/media/20.09f7fcfc.png";